/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Favorite } from './Favorite';
import {
    FavoriteFromJSON,
    FavoriteFromJSONTyped,
    FavoriteToJSON,
} from './Favorite';

/**
 * 
 * @export
 * @interface FavoritesResponse
 */
export interface FavoritesResponse {
    /**
     * 
     * @type {Array<Favorite>}
     * @memberof FavoritesResponse
     */
    data?: Array<Favorite>;
}

/**
 * Check if a given object implements the FavoritesResponse interface.
 */
export function instanceOfFavoritesResponse(value: object): value is FavoritesResponse {
    let isInstance = true;

    return isInstance;
}

export function FavoritesResponseFromJSON(json: any): FavoritesResponse {
    return FavoritesResponseFromJSONTyped(json, false);
}

export function FavoritesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavoritesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FavoriteFromJSON)),
    };
}

export function FavoritesResponseToJSON(value?: FavoritesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FavoriteToJSON)),
    };
}

